package com.trevorwiebe.timesheet.mileage.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.TripType
import kotlinx.datetime.LocalDate

/**
 * The shared, server-side filter state used by both the mileage log and the admin reporting
 * screen. Every field maps directly onto a parameter of [com.trevorwiebe.timesheet.mileage.domain
 * .MileageRepository.queryMileageEntries]; null/empty means "all". The two screens differ only in
 * how they display the resulting entries — not in how they fetch or filter them.
 */
data class MileageFilter(
    val employeeId: String? = null,
    val equipmentId: String? = null,
    val tripTypes: Set<TripType> = emptySet(),
    val startDate: LocalDate? = null,
    val endDate: LocalDate? = null,
    val showStartPicker: Boolean = false,
    val showEndPicker: Boolean = false,
)
